import { Button, DatePicker, Form, Select, Spin } from "antd";
import { filterOption, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router";
import DebounceSelect from "../common/DebounceSelect";
import dayjs from "dayjs";
import { visitTypes } from "./NewMedicalVisit";
import FormPage from "../common/FormPage";

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [dataLoading, setDataLoading] = useState(true);
  const onFinish = (data) => {
    const toSend = {
      ...data,
      employee: data.employee.value,
      doctor: data.doctor.value,
    };
    setLoading(true);
    axiosInstance
      .put(`medicalVisit/${id}`, toSend)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setDataLoading(true);
    axiosInstance
      .get(`medicalVisit/${id}`)
      .then(({ data }) =>
        form.setFieldsValue({
          ...data,
          visitType: data.type,
          employee: { label: data.employee.fullName, value: data.employee.id },
          doctor: {
            label: data.doctor.firstName + " " + data.doctor.lastName,
            value: data.doctor.id,
          },
        }),
      )
      .finally(() => setDataLoading(false));
  }, [id, form]);

  return (
    <Spin spinning={dataLoading}>
      <FormPage title="Modifica visita medica" onFinish={onFinish} form={form}>
        <Form.Item label="Dipendente" rules={[requiredField]} name="employee">
          <DebounceSelect
            fetchOptions={(query) =>
              axiosInstance
                .get("employee", { params: { query, pageSize: 99999 } })
                .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
            }
          />
        </Form.Item>
        <Form.Item label="Tipologia visita" rules={[requiredField]} name="visitType">
          <Select
            options={Object.entries(visitTypes).map(([k, v]) => ({ value: k, label: v }))}
            showSearch
            filterOption={filterOption}
          />
        </Form.Item>
        <Form.Item label="Medico competente" rules={[requiredField]} name="doctor">
          <DebounceSelect
            fetchOptions={(name) =>
              axiosInstance
                .get("doctor", { params: { name, pageSize: 99999 } })
                .then(({ data }) =>
                  data.data.map((x) => ({ label: x.firstName + " " + x.lastName, value: x.id })),
                )
            }
          />
        </Form.Item>
        <Form.Item
          label="Data"
          rules={[requiredField]}
          name="date"
          getValueProps={(value) => ({ value: value && dayjs(value) })}
          normalize={(value) => value && value.format("YYYY-MM-DD")}
        >
          <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
          <Button type="primary" htmlType="submit" loading={loading} disabled={dataLoading}>
            Salva
          </Button>
        </Form.Item>
      </FormPage>
    </Spin>
  );
}
